import { getPageRoute, getS3ImageUrl } from "@/utils/routes";
import Image from "next/image";
import Link from "next/link";
import classes from "./ShowBannersSection.module.css";

interface Props extends WidgetSectionProps {
  section?: boolean;
}

const ShowBannersSection = ({ section = true, widget }: Props) => {
  const settings = widget?.data?.settings || {};
  const col = settings?.col || 3;
  const oneSpan = false;
  const width = settings?.width || 800;
  const showButton = settings?.showButton || false;

  const classNames = [classes.ShowBannersSection, classes["col" + col]];
  if (section) classNames.push(classes.section);

  const banners = widget?.data?.images || [];

  if (banners.length === 0) return null;

  return (
    <div className={classNames.join(" ")}>
      <div className={settings?.containerType === "full" ? "" : "container"}>
        <div
          className={classes.contents}
          style={
            {
              "--col": col || 3,
              "--col-md": Math.min(col || 3, 3),
              gap: (settings?.gap ?? 16) + "px",
            } as React.CSSProperties
          }
        >
          {banners.map((banner, index) => {
            let classNames = `${classes.banner}`;

            let height = settings?.height || 800;

            return (
              <div
                className={classNames}
                key={banner.image || banner.link?.url || `banner-${index}`}
                title={banner.link?.hyperLinkText}
                // style={{
                //   border: "1px solid black",
                // }}
              >
                <Link
                  href={getPageRoute(
                    banner.link?.urlType || "custom",
                    banner.link?.url || ""
                  )}
                  className={!banner.link ? "no-link" : ""}
                >
                  <Image
                    src={getS3ImageUrl(banner.image)}
                    alt={banner.link?.hyperLinkText || "Banner"}
                    blurDataURL={
                      "https://www.unfe.org/wp-content/uploads/2019/04/SM-placeholder.png"
                    }
                    placeholder="blur"
                    layout="responsive"
                    width={width}
                    height={height}
                    unoptimized={true}
                    style={{
                      aspectRatio: width / height,
                      objectFit: (settings?.objectFit || "contain") as any,
                    }}
                  />

                  {showButton && (
                    <div className={classes.buttonContainer}>
                      <p className={classes.title}>{banner.title}</p>
                      <h3 className={classes.description}>
                        {banner.description}
                      </h3>
                      (
                      <div className={classes.button}>
                        <p className={classes.buttonText}>
                          {banner.link?.hyperLinkText || "View All"}
                        </p>
                      </div>
                      )
                    </div>
                  )}
                </Link>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ShowBannersSection;
